<template>
  <div />
</template>

<script>
export default {
  name: 'TicketComments',
}
</script>
